"use strict"

import React from "react"
import ReactNative from "react-native"
import { colors } from "app/lib/styles"
import Rx from "rx"
import PropTypes from "prop-types"

const { View, TextInput } = ReactNative

export default class DebouncedTextInput extends React.Component {
  static defaultProps = {
    debounce: 300,
  }

  static propTypes = {
    onChangeText: PropTypes.func,
    onChangeTextDebounced: PropTypes.func,
  }

  changeSubject = new Rx.ReplaySubject(1)

  componentWillMount() {
    this.changeStream = this.changeSubject.debounce(this.props.debounce)
    this.changeStream.subscribe(val => {
      if (this.props.onChangeTextDebounced) {
        this.props.onChangeTextDebounced(val)
      }
    })
  }

  componentWillUnmount() {
    this.changeSubject.dispose()
  }

  handleChange = value => {
    if (this.props.onChangeText) {
      this.props.onChangeText(value)
    }
    this.changeSubject.onNext(value)
  }

  render() {
    return (
      <TextInput
        ref={this.props.innerRef}
        {...this.props}
        onChangeText={this.handleChange}
      />
    )
  }
}
